import { render, staticRenderFns } from "./NotificationPagesForm.vue?vue&type=template&id=74a39746&scoped=true&"
import script from "./NotificationPagesForm.vue?vue&type=script&lang=js&"
export * from "./NotificationPagesForm.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPagesForm.vue?vue&type=style&index=0&id=74a39746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a39746",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCheckbox,VCol,VRow,VSkeletonLoader})
